export default __webpack_public_path__ + "static/media/popupAlert.e126bf9a.svg";